// KSK064 — icons a merchant can put on a kiosk category tab / item card.
// Keys are what minty_item.kiosk_icon / minty_display_category.kiosk_icon
// store; they must match minty.crm.api `const.kiosk_icons` and the kiosk's
// src/config/kioskIcons.js. `icon` is a Material Icons Round ligature; the
// chef hat has no ligature, so it is drawn from `svg`.
export const KIOSK_ICONS = [
  { key: "chef_hat", label: "Chef's pick", svg: true },
  { key: "exclamation", label: "Notice", icon: "priority_high" },
  { key: "star", label: "Star", icon: "star" },
  { key: "fire", label: "Hot / Spicy", icon: "local_fire_department" },
  { key: "thumb_up", label: "Recommended", icon: "thumb_up" },
  { key: "new", label: "New", icon: "fiber_new" },
  { key: "leaf", label: "Vegetarian", icon: "eco" },
  { key: "heart", label: "Favourite", icon: "favorite" },
];

export const CHEF_HAT_SVG_SHAPES = [
  { tag: "circle", attrs: { cx: 7.5, cy: 10, r: 3.5 } },
  { tag: "circle", attrs: { cx: 12, cy: 7.5, r: 4.5 } },
  { tag: "circle", attrs: { cx: 16.5, cy: 10, r: 3.5 } },
  { tag: "rect", attrs: { x: 7, y: 10, width: 10, height: 6.5 } },
  { tag: "rect", attrs: { x: 7, y: 17.5, width: 10, height: 2.5, rx: 0.5 } },
];
